"use client";

import { useEffect, useState } from "react";

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselOptions,
} from "@/components/ui/carousel";
import { icon } from "@/components/ui/icons";
import { ModuleStatsHero } from "@/lib/types";
import { cn } from "@/lib/ui/cn";

import { Card } from "./Card";
import { Indicators } from "./Indicators.client";

type StatsHeroCarouselProps = {
  cards: ModuleStatsHero["cards"];
};

const carouselOpts: CarouselOptions = {
  align: "start",
  slidesToScroll: 1,
  containScroll: "keepSnaps",
};

export function StatsHeroCarousel({ cards }: StatsHeroCarouselProps) {
  const [api, setApi] = useState<CarouselApi>();

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCurrent(api.selectedScrollSnap());

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <Carousel setApi={setApi} opts={carouselOpts}>
      <CarouselContent rootClassName="px-padding-global" className="ml-0">
        {cards.map((card, index) => {
          const Icon = icon(card.iconName || "Documents");

          return (
            <CarouselItem
              key={card._key}
              className={cn("pr-gap-element-md tablet:py-[72px] basis-auto pl-0")}
            >
              <Card card={card} Icon={Icon} isActive={current === index} />
            </CarouselItem>
          );
        })}
      </CarouselContent>
      <div className="px-padding-global">
        <Indicators />
      </div>
    </Carousel>
  );
}
